import { React, useEffect, useState, useRef } from "react";
import axios from "axios";
import { browserName, browserVersion } from "react-device-detect";
import { checkPaymentStatus, getGBussinessInfo, getPaymentLinkSetting, logEvent, randomTid, reqPaymentStatus, getPinelabsSettings } from "../services/apiServices.js";
import tranImg from "./../components/images/Transactions.svg";
import ccImg from "./../components/images/paymentsicons/card-credit.svg";
import cash from "./../components/images/paymentsicons/cash.svg";
import coupon from "./../components/images/paymentsicons/coupon.svg";
import multiple from "./../components/images/paymentsicons/multiple-payments.svg";
import phonepeIcon from "./../components/images/phonepe-icon.svg"
import otherpayments from "./../components/images/paymentsicons/other-payment.svg";
import uiImg from "./../components/images/paymentsicons/upi.svg";
import wallet from "./../components/images/paymentsicons/wallet.svg";
import PageError from "./PageError.js";
import Popup from "../components/Popup.js";
import PaymentLink from "../components/PaymentLink.js";
import DatePicker from "react-datepicker";
import {
  MDBAlert,
} from 'mdb-react-ui-kit';
import ReverseTimer from "../components/ReverseTimer.js";
import {
  isDefaultTransIdRequired,
  multipleSplitRequiresTransId,
  validateBusinessTransId,
} from "../utils/paymentTransIdRules";

const Payments = (props) => {
  const isAdmin = (() => {
    try { return JSON.parse(localStorage.getItem("loggedUserInfo"))?.rolevalues.includes(1); }
    catch { return false; }
  })();
  const [inputAmount, setInputAmount] = useState(0)
  const [paymenttype, setPaymenttype] = useState(0);
  const [dpaymethods, setDpaymethods] = useState([]);
  const [dpaymethodsRequireTransId, setDpaymethodsRequireTransId] = useState([]);
  const [userpaymethods, setUserpaymethods] = useState([]);
  const [showMulitple, setShowMulitple] = useState(false);
  const [userpayselect, setUserpayselect] = useState(null);
  const [showCoupon, setShowCoupon] = useState(false);
  const [balance, setBalance] = useState(0);
  const [balmode, setBalmode] = useState(1);
  const [cashChecked, setCashChecked] = useState(true);
  const [ccChecked, setCcChecked] = useState(true);
  const [upiChecked, setUpiChecked] = useState(true);
  const [walletChecked, setWalletChecked] = useState(true);
  const [apiError, setApiError] = useState(false);
  const [Paymetlinkobj, setPaymetlinkobj] = useState({})
  const [totalamount, setTotalamount] = useState(0);
  const [curSelMode, setCurSelMode] = useState(0);
  const [selectedChecks, setSelecedChecks] = useState([]);
  const [paymentLink, setPaymentLink] = useState(false);
  const [sentScreenPopup, setSentScreenPopup] = useState(false)
  const minutes = 20;
  const [createdDate, setCreatedDate] = useState(new Date());
  const [payInfo, setPayInfo] = useState({
    cash_amt: "",
    cc_amt: "",
    upi_amt: "",
    upi_input: "",
    wallet_amt: "",
    wallet_input: "",
    userpaymethod: "",
  });

  const [transId, setTransaId] = useState("");
  const [showError, setShowError] = useState(false);
  const [transIdFieldError, setTransIdFieldError] = useState("");

  const BACKEND_API_URL  = process.env.REACT_APP_PRIMARY_SERVER_URL;
  const [showPinelabs, setShowPinelabs]         = useState(false);
  const [plAmount, setPlAmount]                 = useState("");
  const [plStage, setPlStage]                   = useState("idle"); // idle | processing | done
  const [plOrder, setPlOrder]                   = useState(null);
  const [plTxnStatus, setPlTxnStatus]           = useState(null);
  const [plError, setPlError]                   = useState("");
  const [plCancelling, setPlCancelling]         = useState(false);
  const [plStuckTxn,  setPlStuckTxn]           = useState(null); // { ptrid, amount } for 409
  const [plPayMode,   setPlPayMode]             = useState(1);   // 1=Card, 10=UPI
  const plIntervalRef                           = useRef(null);
  const plTimeoutRef                            = useRef(null);

  // Maps Pine Labs PaymentMode → system mode: 1=Cash 2=Card 3=UPI
  const plModeToSysMode = (plMode) => {
    if (plMode == null || plMode === '') return 2;
    const num = Number(plMode);
    if (!isNaN(num) && String(plMode).trim() !== '') {
      if (num === 2)                          return 1; // Cash
      if (num === 1)                          return 2; // Card
      if (num === 10 || num === 11 || num === 12) return 3; // UPI / UPI QR
      return 2;
    }
    const m = String(plMode).toUpperCase();
    if (m.includes('UPI') || m.includes('QR') || m.includes('BHIM')) return 3;
    if (m.includes('CASH'))                                            return 1;
    return 2;
  };

  // Device selection — persisted in localStorage so each terminal remembers its device
  const PL_DEVICE_KEY    = 'pinelabsActiveDevice';
  const PL_PENDING_KEY   = 'pinelabsPendingOrder'; // { orderId, ptrid, amount } — survives refresh
  const [plDevices, setPlDevices]               = useState([]);
  const [plActiveDevice, setPlActiveDevice]     = useState(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(PL_DEVICE_KEY));
      if (!stored) return null;
      const currentGymId = localStorage.getItem("loggedUserInfo")
        ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : null;
      // If the device was saved for a different gym, discard it
      if (stored._gymId && stored._gymId !== currentGymId) {
        localStorage.removeItem(PL_DEVICE_KEY);
        return null;
      }
      return stored;
    } catch { return null; }
  });
  const [plShowDevicePicker, setPlShowDevicePicker] = useState(false);

  const plSelectDevice = (device) => {
    const gymid = localStorage.getItem("loggedUserInfo")
      ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : null;
    const deviceWithGym = { ...device, _gymId: gymid };
    setPlActiveDevice(deviceWithGym);
    localStorage.setItem(PL_DEVICE_KEY, JSON.stringify(deviceWithGym));
    setPlShowDevicePicker(false);
  };

  const plStopPolling = () => {
    if (plIntervalRef.current) { clearTimeout(plIntervalRef.current); plIntervalRef.current = null; }
    if (plTimeoutRef.current)  { clearTimeout(plTimeoutRef.current);  plTimeoutRef.current  = null; }
  };
  useEffect(() => () => plStopPolling(), []);

  // Resume polling if page was refreshed mid-payment
  useEffect(() => {
    async function restorePolling() {
      try {
        const saved = localStorage.getItem(PL_PENDING_KEY);
        if (!saved) return;
        const order = JSON.parse(saved);
        if (!order?.ptrid) return;

        // Verify this PTRID still exists in the DB before restoring
        const { data } = await axios.post(`${BACKEND_API_URL}pinelabs/payment-status/${order.ptrid}`);
        if (data.status === 'PAID' || data.status === 'CANCELLED' || data.status === 'FAILED' || data.status === 'VOID') {
          // Already settled — clean up silently
          localStorage.removeItem(PL_PENDING_KEY);
          return;
        }
        // Still pending — restore processing state and resume polling
        setPlOrder(order);
        setPlStage('processing');
        setPlError('Reconnected — waiting for payment result from terminal...');
        plStartPolling(order.ptrid, order.orderId);
      } catch (err) {
        // 404 or 500 = stale PTRID, clear it
        localStorage.removeItem(PL_PENDING_KEY);
      }
    }
    restorePolling();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    async function fetchPinelabsDevices() {
      const gymid = localStorage.getItem("loggedUserInfo")
        ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : null;
      if (!gymid) return;
      try {
        const res = await getPinelabsSettings(gymid);
        if (res && res.ok) {
          const devs = await res.json(); // flat array of device docs
          setPlDevices(devs);
          // Auto-select if only one device and none stored yet
          if (devs.length === 1 && !localStorage.getItem(PL_DEVICE_KEY)) {
            plSelectDevice(devs[0]);
          }
        }
      } catch (e) { /* silent */ }
    }
    fetchPinelabsDevices();
  }, []);

  const AUTO_CANCEL_MS = 122 * 1000; // 122 seconds — free the terminal faster

  const plStartPolling = (ptrid, orderId) => {
    // Auto-cancel after 122 seconds if POS device has not responded
    plTimeoutRef.current = setTimeout(async () => {
      plStopPolling();
      setPlCancelling(true);
      try {
        await axios.post(`${BACKEND_API_URL}pinelabs/cancel/${ptrid}`);
      } catch (e) { console.warn('PL auto-cancel error:', e.message); }
      setPlCancelling(false);
      setPlTxnStatus({ status: 'CANCELLED', responseMessage: 'Auto-cancelled — no response from POS after 120 seconds.' });
      setPlStage('done');
    }, AUTO_CANCEL_MS);

    let pollCount = 0;
    const poll = async () => {
      if (!plIntervalRef.current) return; // stopped
      pollCount++;
      try {
        const { data } = await axios.post(`${BACKEND_API_URL}pinelabs/payment-status/${ptrid}`);
        if (data.status !== 'PENDING') {
          plStopPolling();
          localStorage.removeItem(PL_PENDING_KEY);
          setPlTxnStatus(data);
          setPlStage('done');
          if (data.status === 'PAID') {
            setAlerttxt("Pine Labs Payment Successful.");
            setShowPinelabs(false);
            try {
              const cur = JSON.parse(localStorage.getItem("selItems") || "{}");
              localStorage.setItem("selItems", JSON.stringify({
                ...cur,
                ispinelabs: true,
                transId: data.transactionLogId || orderId || ptrid,
              }));
            } catch (_) {}
            donePayment(plModeToSysMode(data.paymentMode));
          }
          return;
        }
      } catch (err) {
        const status = err.response?.status;
        if (status === 404 || status === 500) {
          plStopPolling();
          localStorage.removeItem(PL_PENDING_KEY);
          setPlStage('idle');
          setPlOrder(null);
          return;
        }
        console.error('PL polling error:', err.message);
      }
      // Fast poll first 20s (every 2s), then settle to every 3s
      const nextDelay = pollCount <= 10 ? 2000 : 3000;
      plIntervalRef.current = setTimeout(poll, nextDelay);
    };

    // Start first poll after 2 seconds
    plIntervalRef.current = setTimeout(poll, 2000);
  };

  const handlePinelabsPay = async () => {
    const amt = parseFloat(plAmount);
    if (!amt || amt <= 0) { setPlError('Enter a valid amount'); return; }
    if (!plActiveDevice) { setPlError('Please select a POS device first.'); setPlShowDevicePicker(true); return; }
    plStopPolling(); // kill any stale interval from a previous/restored session
    setPlError('');
    setPlStage('processing');
    try {
      const userInfo = localStorage.getItem("loggedUserInfo")
        ? JSON.parse(localStorage.getItem("loggedUserInfo")) : {};
      const gymid = userInfo.gymid || '';
      const sId   = userInfo._id  || '';
      const tId   = getToken();
      const orderId = `pl_${Date.now()}_${Math.floor(Math.random() * 1000)}`;

      const tsdata = localStorage.getItem("selItems") ? JSON.parse(localStorage.getItem("selItems")) : [];
      const tmdata = localStorage.getItem("allData")  ? JSON.parse(localStorage.getItem("allData"))  : {};
      const transactionSnapshot = {
        ...tsdata,
        payinfo: { mode: 2, balmode: 1, info: payInfo, balance: 0 },
        ispinelabs: true,
        balance:    0,
        tId,
        totalPrice: tmdata.totalPrice,
        ref_tId:    tmdata.ref_tId,
        price:      totalamount,
        type:       paymenttype,
        token:      Array.isArray(tsdata) && tsdata[0]?.token ? tsdata[0].token : -1,
        PaymentLinkId: -1,
        transDate:  tmdata.transDate,
        transId:    transId,
        parentname: tmdata.parentname  || {},
        gstobj:     tmdata.gstobject   || {},
        sId,
        gymid,
      };

      const { data } = await axios.post(`${BACKEND_API_URL}pinelabs/initiate-pos-payment`, {
        amount: amt,
        orderId,
        gymId:              gymid,
        tId,
        sId,
        transactionSnapshot,
        allowedPaymentMode: plPayMode,
        merchantId:         plActiveDevice.merchantId,
        securityToken:      plActiveDevice.securityToken,
        clientId:           plActiveDevice.clientId,
        storeId:            plActiveDevice.storeId,
        deviceNumber:       plActiveDevice.deviceNumber,
      });

      const plOrderData = { orderId: data.orderId || orderId, ptrid: data.ptrid, amount: amt };
      setPlOrder(plOrderData);
      localStorage.setItem(PL_PENDING_KEY, JSON.stringify(plOrderData));
      setTransaId(plOrderData.orderId);
      plStartPolling(data.ptrid, plOrderData.orderId);
    } catch (err) {
      const msg = err.response?.data?.error || err.response?.data?.message || err.message;
      if (err.response?.status === 409) {
        const d = err.response?.data || {};
        setPlStuckTxn({ ptrid: d.existingPtrid, amount: d.existingAmount });
        setPlError(`Terminal busy: open transaction PTRID ${d.existingPtrid} (${d.existingAmount}) must be cancelled first.`);
      } else {
        setPlError(msg);
      }
      setPlStage('idle');
    }
  };

  const handlePinelabsCancel = async () => {
    if (!plOrder?.ptrid) { handlePinelabsReset(); return; }
    setPlCancelling(true);
    plStopPolling();
    try {
      const { data } = await axios.post(`${BACKEND_API_URL}pinelabs/force-cancel/${plOrder.ptrid}`);
      setPlCancelling(false);
      if (data.status === 'PAID') {
        // Customer completed payment on the terminal while retrying cancel
        localStorage.removeItem(PL_PENDING_KEY);
        setAlerttxt("Pine Labs Payment Successful.");
        setShowPinelabs(false);
        try {
          const cur = JSON.parse(localStorage.getItem("selItems") || "{}");
          localStorage.setItem("selItems", JSON.stringify({ ...cur, ispinelabs: true, transId: data.transactionLogId || plOrder?.orderId || plOrder?.ptrid }));
        } catch (_) {}
        donePayment(plModeToSysMode(data.paymentMode));
      } else {
        // Cancelled (or terminal auto-cancel pending) — clear pending key and show done
        localStorage.removeItem(PL_PENDING_KEY);
        setPlTxnStatus({ status: 'CANCELLED', responseMessage: data.message || 'Transaction cancelled.' });
        setPlStage('done');
      }
    } catch (err) {
      setPlCancelling(false);
      const data = err.response?.data || {};
      if (err.response?.status === 202 || data.inProgress) {
        // DB is marked cancelled — let user start a new transaction now.
        // Terminal will auto-cancel the old one within 1 minute.
        localStorage.removeItem(PL_PENDING_KEY);
        setPlTxnStatus({ status: 'CANCELLED', responseMessage: 'Cancel sent. Terminal will clear in ~1 min. You can start a new transaction.' });
        setPlStage('done');
      } else {
        const msg = data.message || data.error || data.responseMessage || '';
        setPlError(msg || 'Cancel failed. Please try again.');
        plStartPolling(plOrder.ptrid, plOrder?.orderId);
      }
    }
  };

  const handlePinelabsReset = () => {
    plStopPolling();
    localStorage.removeItem(PL_PENDING_KEY);
    setPlAmount(String(totalamount));
    setPlStage('idle');
    setPlOrder(null);
    setPlTxnStatus(null);
    setPlError('');
    setPlCancelling(false);
    setPlStuckTxn(null);
  };

  const handleCancelStuck = async () => {
    if (!plStuckTxn?.ptrid) return;
    setPlCancelling(true);
    setPlError('Cancelling stuck transaction…');
    try {
      const { data } = await axios.post(`${BACKEND_API_URL}pinelabs/force-cancel/${plStuckTxn.ptrid}`);
      if (data.status === 'PAID') {
        // Customer actually completed the stuck transaction — treat as success
        setPlStuckTxn(null);
        setPlError('');
        setAlerttxt("Pine Labs Payment Successful.");
        setShowPinelabs(false);
        try {
          const cur = JSON.parse(localStorage.getItem("selItems") || "{}");
          localStorage.setItem("selItems", JSON.stringify({ ...cur, ispinelabs: true, transId: data.transactionLogId || plStuckTxn?.ptrid }));
        } catch (_) {}
        donePayment(plModeToSysMode(data.paymentMode));
        return;
      }
      // Cancelled — clear stuck state and auto-retry the payment
      setPlStuckTxn(null);
      setPlError('');
      setPlCancelling(false);
      handlePinelabsPay(); // auto-retry now that terminal is clear
    } catch (err) {
      const d = err.response?.data || {};
      const msg = d.responseMessage || d.error || d.message || 'Cancel failed';
      setPlError(`Could not cancel stuck transaction: ${msg}. Try again or wait ~3 min for auto-timeout.`);
      setPlCancelling(false);
    }
  };

  function updateBalance(value, updatefield) {
    let othertotal = 0;
    if (curSelMode === 6) {
      othertotal += payInfo.cash_amt * 1;
      othertotal += payInfo.cc_amt * 1;
      othertotal += payInfo.upi_amt * 1;
      othertotal += payInfo.wallet_amt * 1;
    } else {
      othertotal = value;
    }
    console.log("11111111111112222222222222");
    let balamount = totalamount * 1 - othertotal * 1;
    console.log(value);
    console.log(balamount);
    setBalance(balamount < 0 ? 0 : balamount);
  }
  function updatepayInfo(value, balmode) {
    //setBalmode(balmode);
    return setPayInfo((prev) => {
      return { ...prev, ...value };
    });
  }
  const [Alerttxt, setAlerttxt] = useState("");
  const [PaymentLinkId, setPaymentLinkId] = useState("")
  const [dateselector, setdateselector] = useState(false)
  function paymentLinkSent(id) {
    let uniqueID = id;
    setPaymentLink(false);
    setSentScreenPopup(true);
    setPaymentLinkId(uniqueID);
  }
  function CreatedDate(date, id) {
    // let tselObj = selItems.filter((tObj) => tObj._id === id)[0];
    // tselObj.cdate = date;
    setCreatedDate(date);
    handleTransDate(date)
  }

  function handleTransDate(date) {
    console.log("in searchbar handleTransDate ", date);
    props.handleTransdate(date)
  }
  async function checkingPaymentStatus(val) {
    if (val === 0) {
      setSentScreenPopup(false);
      setPaymentLinkId("");
      setAlerttxt("Payment link was expired or failed. Try again.");
      return true;
    }
    if (sentScreenPopup) {
      let response = await checkPaymentStatus(PaymentLinkId);
      if (!response || response === "false") {
        setSentScreenPopup(false);
        setAlerttxt("Payment link was expired or failed. Try again.");
        setPaymentLinkId("");
        setApiError(true);
        return true;
      } else {
        const resObject = await response.json();
        console.log(resObject);
        if (resObject.message === true) {
          donePayment(-2);
          setAlerttxt("Payment Done Sucessfull.");
          setSentScreenPopup(false);
          return true;
        }
        if (resObject.message === "failed") {
          setSentScreenPopup(false);
          setPaymentLinkId("");
          setAlerttxt("Payment link was expired or failed. Try again.");
          return true;
        }
      }
    } else {
      return true;
    }
    return false;
  }
  async function requestPaymentStatus() {
    if (sentScreenPopup) {
      let response = await reqPaymentStatus(PaymentLinkId);
      console.log("after request");
      if (!response) {
        return;
      }
      if (response === "false") {
        setApiError(true)
      } else {
        const resObject = await response.json();
        console.log(resObject);
      }
    }
  }
  function handleChange(e, value, checkString) {
    // e.preventDefault();
    setBalmode(value);

    console.log(value);
    switch (checkString) {
      case "cash":
        setCashChecked(!cashChecked);
        if (!cashChecked) {
          let remain = selectedChecks.filter((item) => item !== "cash");
          setSelecedChecks(remain);
        } else {
          setSelecedChecks([...selectedChecks, "cash"]);
        }
        break;
      case "cc":
        setCcChecked(ccChecked ? false : true);
        if (!ccChecked) {
          let remain = selectedChecks.filter((item) => item !== "cc");
          setSelecedChecks(remain);
        } else {
          setSelecedChecks([...selectedChecks, "cc"]);
        }
        break;
      case "upi":
        setUpiChecked(upiChecked ? false : true);
        if (!upiChecked) {
          let remain = selectedChecks.filter((item) => item !== "upi");
          setSelecedChecks(remain);
        } else {
          setSelecedChecks([...selectedChecks, "upi"]);
        }
        break;
      case "wallet":
        setWalletChecked(walletChecked ? false : true);
        if (!walletChecked) {
          let remain = selectedChecks.filter((item) => item !== "wallet");
          setSelecedChecks(remain);
        } else {
          setSelecedChecks([...selectedChecks, "wallet"]);
        }
        break;
      default:
        // Handle unexpected values of checkString
        break;
    }

    console.log("cash value === > " + cashChecked);
    console.log("cc value === > " + ccChecked);
    console.log("upi value === > " + upiChecked);
    console.log("wallet value === > " + walletChecked);

  }
  let selecteditems = localStorage.getItem("selItems") ? JSON.parse(localStorage.getItem("selItems")) : [];

  function setToken(tTransactionId) {
    try {
      localStorage.setItem("transactionId", tTransactionId);
    } catch (e) {
      console.log("Error while creating session.. " + e);
    }
  }
  function getToken() {
    try {
      const tokenString = localStorage.getItem("transactionId");
      return tokenString;
    } catch (e) {
      console.log("error :::::: " + e);
      return;
    }
  }

  console.log(JSON.parse(localStorage.getItem("allData")));
  console.log(JSON.parse(localStorage.getItem("selItems")));
  useEffect(() => {
    processAllData();
    function processAllData() {
      let tmdata = JSON.parse(localStorage.getItem("allData"));
      let tprice = localStorage.getItem("Tprice") ? localStorage.getItem("Tprice") : 0;
      if (tmdata.isplan && tmdata.isplan === 3) {
        // for due amount 
        setPaymenttype(2);
        setTotalamount(tmdata.price);
        setdateselector(true)
        generateToken();
      } else {
        setPaymenttype(1);

        setTotalamount(tprice);

      }
    }

    async function generateToken() {
      if (getToken()) return;
      console.log("Generating Token");
      try {
        const response = await randomTid();
        const data = await response.json();

        if (!data || data === false) {
          setApiError(true);
          return;
        }



        const transactionId = data?.id || data;

        if (transactionId) {
          console.log("Generated transactionId:", transactionId);
          setToken(transactionId);
          return;
        }
      } catch (error) {
        console.error("Error generating transactionId from API:", error);
      }

      // Fallback if API fails
      const fallbackTransactionId = Math.random().toString().substring(2, 8);
      console.log("Using fallback transactionId:", fallbackTransactionId);
      setToken(fallbackTransactionId);
    }


  }, []);


  const handleReload = () => {
    window.location.reload();
  }
  useEffect(() => {
    async function fetchData() {
      if (localStorage.getItem("loggedUserInfo")) {
        const response = await getGBussinessInfo(
          JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
        );
        if (!response) {
          return;
        }
        if (response === "false") {
          setApiError(true)
        } else {
          const record = await response.json();
          if (!record) {
            return;
          }

          setDpaymethods(record.dpaymethods);
          setDpaymethodsRequireTransId(record.dpaymethodsRequireTransId || []);
          let temOpts = [];
          record.userpaymethods.forEach((opt) => {
            if (opt.check) {
              temOpts.push(opt._id);
            }
          });

          setUserpaymethods(record.userpaymethods);
        }
        const paymentLinkSetting = await getPaymentLinkSetting(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
        const paymentLinkSettings = await paymentLinkSetting.json();
        if (paymentLinkSettings.gymid) {
          setPaymetlinkobj(paymentLinkSettings);
        }
      }
    }
    fetchData();
  }, []);
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (sentScreenPopup) {
        event.preventDefault();
        event.returnValue = ''; // Required for Chrome to show the prompt
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [sentScreenPopup]);

  async function donePayment(value) {
    if (typeof value === "number" && value >= 1 && value <= 7) {
      setCurSelMode(value);
    }
    const valuee = (value === -1) ? curSelMode : value
    if (Number(value) < -2) {
      let required = false;
      if (valuee >= 1 && valuee <= 5) {
        required = isDefaultTransIdRequired(valuee, dpaymethodsRequireTransId);
      } else if (valuee === 6) {
        required = multipleSplitRequiresTransId(payInfo, dpaymethodsRequireTransId);
      } else if (valuee >= 7) {
        const item = userpaymethods[valuee - 7];
        required = !!(item && item.requireTransactionId);
      }
      const v = validateBusinessTransId(transId, required);
      if (!v.ok) {
        setTransIdFieldError(v.message);
        setShowError(true);
        return;
      }
    }
    setTransIdFieldError("");
    setShowError(false);
    console.log("Payment Mode:: " + valuee);
    console.log("Payment Info:: ");
    console.log(payInfo);
    console.log(balance);
    let ip = localStorage.getItem("ipaddress");
    let gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
    let username1 = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : '';
    let browserinfo = browserName + "-" + browserVersion + ".0.0";
    let Eventtype = "payment";
    let flag = `Payment Done Successfull (${getToken()})`;
    logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
    let tsdata = JSON.parse(localStorage.getItem("selItems"));
    let tmdata = JSON.parse(localStorage.getItem("allData"));
    let gstinfo = JSON.parse(localStorage.getItem("gstInfo"));
    let bal = balance;
    let totalAmount = totalamount;
    if (
      value === 1 ||
      value === 2 ||
      value === 3 ||
      value === 4 ||
      value === -2 ||
      value === -3
    ) {
      bal = 0;
      totalAmount = totalamount;
    }


    localStorage.setItem(
      "selItems",
      JSON.stringify({
        ...tsdata,
        payinfo: {
          mode: valuee,
          balmode: balmode,
          info: payInfo,
          balance: bal,
          // Preserve Pine Labs orderId so paymentInfo.transid is set correctly on the backend
          ...(tsdata?.ispinelabs && tsdata?.transId ? { transid: tsdata.transId } : {}),
        },
        balance: bal,
        tId: getToken(),
        totalPrice: tmdata.totalPrice,
        ref_tId: tmdata.ref_tId,
        price: totalAmount,
        type: paymenttype,
        token: tsdata[0]?.token ? tsdata[0].token : -1,
        PaymentLinkId: PaymentLinkId !== "" ? PaymentLinkId : -1,
        transDate: tmdata.transDate,
        // For Pine Labs: use orderId already stored in localStorage, not stale React state
        transId: (tsdata?.ispinelabs && tsdata?.transId) ? tsdata.transId : transId,
        parentname: tmdata.parentname ? tmdata.parentname : {},
        gstobj: tmdata.gstobject ? tmdata.gstobject : {}
        // gstinfo? gstinfo: {}

      })
    );
    props.onsubmit();
  }

  function payAmount(obj, index) {
    // Set selected mode before validation so "Transaction ID *" vs "(optional)" matches when validation fails
    if (obj && obj.option !== undefined && obj.option !== null) {
      setCurSelMode(obj.option);
    } else if (index != null && index >= 7) {
      setCurSelMode(index);
    }

    if (obj && obj.option && [1, 2, 3, 4].includes(obj.option)) {
      const req = isDefaultTransIdRequired(obj.option, dpaymethodsRequireTransId);
      const v = validateBusinessTransId(transId, req);
      if (!v.ok) {
        setTransIdFieldError(v.message);
        setShowError(true);
        return;
      }
    } else {
      const v = validateBusinessTransId(transId, false);
      if (!v.ok) {
        setTransIdFieldError(v.message);
        setShowError(true);
        return;
      }
    }
    setTransIdFieldError("");
    setShowError(false);

    console.log(obj.option);
    console.log(index);
    updateBalance(0);
    setShowCoupon(false);
    setShowMulitple(false);

    if (obj && obj.option) {
      if ([1, 2, 3, 4].includes(obj.option)) {
        donePayment(obj.option);
      }

      else if (obj.option === 5) {
        setShowCoupon(true);
      }

      else if (obj.option === 6) {
        setShowMulitple(true);
      }
    }

    if (index && index >= 7) {
      const defaultAmount = Number(totalamount);
      setInputAmount(defaultAmount)
      updatepayInfo({
        userpaymethod: obj.title,
        usr_input: defaultAmount
      });

      setBalance(0);

      setCurSelMode(index);

      const CustomPaymentInput = () => {
        const [inputValue, setInputValue] = useState(defaultAmount.toString());

        const handleInputChange = (e) => {
          const value = e.target.value;
          setInputValue(value);

          updatepayInfo({ usr_input: value });

          const amount = Number(value) || 0;
          const newBalance = totalamount - amount;
          setBalance(newBalance < 0 ? 0 : newBalance);
        };

        return (
          <>
            <span>{obj.label}</span>
            <span>
              <span>
                Amount <img className="w-11" src={tranImg} alt="Amount" />
              </span>{" "}
              <input
                className="splitinput w-50"
                type="text"
                alt="pay"
                value={inputValue}
                onChange={handleInputChange}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </span>
          </>
        );
      };
      setUserpayselect(<CustomPaymentInput key={Date.now()} />);
    } else {
      setUserpayselect(null);
      updatepayInfo({ userpaymethod: "" });
    }
  }
  console.log(dpaymethods);

  const onTransIdChange = (e) => {
    const value = e.target.value;

    setTransaId(value);
    setShowError(false);
    setTransIdFieldError("");
  }

  return (
    <>
      {apiError ? <PageError handleReload={handleReload} /> :
        <div className="">
          {/* <div
          className="gym-container"
          style={{ marginTop: "20px" }}
          id="showcase"
        ></div> */}
          <div className="">
            <div className="d-flex align-items-center ">
              {dateselector &&
                <>
                  <p className="mb-0">
                    <b>
                      Transaction Date
                    </b>
                  </p>
                  <div className="ms-2">
                    <DatePicker
                      selected={createdDate}
                      onChange={(date) => CreatedDate(date)}
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      dateFormat="MM-dd-yyyy h:mm aa"
                      className="inp-clrdate-Small1"
                    />
                  </div>
                </>
              }
            </div>
            <div className="d-flex space-between mb-2 mt-4 mob-block">
              <p>All transactions are secure and encrypted.</p>
              <p>
                <b>
                  Total To Pay:
                  <img className="w-11" src={tranImg} alt="Pay" /> {totalamount}
                </b>
              </p>
            </div>

            <div className="d-flex flex-wrap">
              {dpaymethods &&
                dpaymethods.filter((item) => item === 1).length > 0 && (
                  <div
                    style={{ cursor: "pointer" }}
                    className="paymt-clr-1"
                    onClick={(e) => payAmount({ option: 1 })}
                  > <img className="w-25" src={cash} alt="Cash" />
                    Cash
                  </div>
                )}
              {dpaymethods &&
                dpaymethods.filter((item) => item === 2).length > 0 && (
                  <div
                    className="paymt-clr-2"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => payAmount({ option: 2 })}
                  ><img className="w-25" src={ccImg} alt="Card" />
                    Card
                  </div>
                )}
              {dpaymethods &&
                dpaymethods.filter((item) => item === 3).length > 0 && (
                  <div
                    className="paymt-clr-3"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => payAmount({ option: 3 })}
                  ><img className="w-25" src={uiImg} alt="UPI" />
                    UPI
                  </div>
                )}
              {dpaymethods &&
                dpaymethods.filter((item) => item === 4).length > 0 && (
                  <div
                    className="paymt-clr-4"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => payAmount({ option: 4 })}
                  ><img className="w-25" src={wallet} alt="Wallet" />
                    Wallet
                  </div>
                )}
              {dpaymethods &&
                dpaymethods.filter((item) => item === 5).length > 0 && (
                  <div
                    className="paymt-clr-5"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => payAmount({ option: 5 })}
                  ><img className="w-25" src={coupon} alt="Coupon" />
                    Coupon
                  </div>
                )}
              {userpaymethods &&
                userpaymethods.map(
                  (item, index) =>
                    item.check && (
                      <>
                        <div
                          className={"paymt-clr-"
                            + (index + 7)}
                          style={{ cursor: "pointer" }}
                          onClick={(e) => payAmount(item, index + 7)}
                        ><img className="w-25" src={otherpayments} alt={item.title} />
                          {item.title}
                        </div>
                      </>
                    )
                )}
              <div
                className="paymt-clr-Multiple"
                style={{ cursor: "pointer" }}
                onClick={(e) => payAmount({ option: 6 })}
              ><img className="w-25" src={multiple} alt="Multiple" />
                Multiple
              </div>



              {Paymetlinkobj.toggle
                && Paymetlinkobj.status === 1
                && <div
                  className="paymt-clr-2 phonepecolor"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => { setPaymentLink(true) }}
                ><img className="w-25" src={phonepeIcon} alt="payment link" />
                  Send Payment Link
                </div>}
              {plDevices.length > 0 && (
                <div
                  className="paymt-clr-2"
                  style={{ cursor: "pointer", background: "#1a237e", color: "#fff" }}
                  onClick={() => { setPlAmount(String(totalamount)); setPlStage("idle"); setPlError(""); setShowPinelabs(true); }}
                >
                  <img className="w-25" src={ccImg} alt="Pine Labs POS" />
                  Pine Labs
                </div>
              )}
            </div>
            {/* <div className="d-flex flex-wrap">
              <div
                className="paymt-clr-Multiple"
                style={{ cursor: "pointer" }}
                onClick={(e) => payAmount({ option: 6 })}
              ><img className="w-25" src={multiple} alt="Multiple" />
                Multiple
              </div>



              {Paymetlinkobj.toggle
                && Paymetlinkobj.status === 1
                && <div
                  className="paymt-clr-2 phonepecolor"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => { setPaymentLink(true) }}
                ><img className="w-25" src={phonepeIcon} alt="payment link" />
                  Send Payment Link
                </div>}

            </div> */}

            <div className="mt-4 mb-4 d-flex flex-wrap align-items-center">
              <label style={{ marginRight: "15px" }} className="mb-0">
                Transaction ID
                {curSelMode >= 1 && curSelMode <= 5 && isDefaultTransIdRequired(curSelMode, dpaymethodsRequireTransId) ? (
                  <span className="text-danger"> *</span>
                ) : curSelMode === 6 && multipleSplitRequiresTransId(payInfo, dpaymethodsRequireTransId) ? (
                  <span className="text-danger"> *</span>
                ) : curSelMode >= 7 && userpaymethods[curSelMode - 7]?.requireTransactionId ? (
                  <span className="text-danger"> *</span>
                ) : (
                  <span className="text-muted small"> (optional)</span>
                )}
              </label>{" "}
              <label className="fw-600 mr-2 mb-0">
                <input type="text"
                  className="form-control"
                  value={transId}
                  minLength={4}
                  onChange={(e) => onTransIdChange(e)}
                  onBlur={(e) => {
                    const v = validateBusinessTransId(e.target.value, false);
                    if (!v.ok) {
                      setTransIdFieldError(v.message);
                      setShowError(true);
                    } else {
                      setShowError(false);
                    }
                  }}
                />
              </label>

            </div>
            {(transIdFieldError || showError) && (
              <div style={{ color: "red", margin: "5px" }}>
                {transIdFieldError || "Please enter at least 4 characters for Transaction ID, or leave it empty."}
              </div>
            )}


            {userpayselect && <div className="splitenter">{userpayselect}</div>}
            {showCoupon && (
              <>
                <div className="splitenter">
                  <span>
                    Enter Coupon Code{" "}
                    <input
                      className="coupen-code"
                      type="text"
                      onChange={(e) =>
                        updatepayInfo({ coupon_input: e.target.value })
                      }
                      placeholder="Enter Code Here"
                    />{" "}
                  </span>
                  <span>
                    <span>
                      {" "}
                      Coupon Amount <img className="w-11" src={tranImg} alt="Coupon" />
                    </span>{" "}
                    <input
                      className="splitinput w-50"
                      type="text"
                      onChange={(e) =>
                        updatepayInfo({ coupon_amt: e.target.value })
                      }
                      onKeyUp={(e) => updateBalance(e.target.value)}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </span>{" "}
                </div>
              </>
            )}
            {showMulitple && (
              <>
                <div className="pt-1 pb-1">Pay balance amount using
                  <div className="duepaymentradio">
                    <div
                      onClick={(e) => handleChange(e, 1, "cash")}
                      style={{ zIndex: 2 }}
                    >
                      <span>

                        Enter cash to be paid
                      </span>
                    </div>
                    <span>
                      <span>
                        <img className="w-11" src={tranImg} alt="Cash" />
                      </span>

                      <input
                        className="splitinput w-50"
                        type="text"
                        // disabled={cashChecked ? true : false}
                        onChange={(e) =>
                          updatepayInfo({ cash_amt: e.target.value })
                        }
                        onKeyUp={(e) => updateBalance(e.target.value)}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </span>
                  </div>
                </div>
                <div className="duepaymentradio">
                  <div
                    onClick={(e) => handleChange(e, 2, "cc")}
                    style={{ zIndex: 2 }}
                  >
                    <span>

                      Credit / Debit Card
                    </span>
                  </div>
                  <span>
                    <span>
                      <img className="w-11" src={tranImg} alt="Card" />
                    </span>
                    <input
                      className="splitinput w-50"
                      type="text"
                      // disabled={ccChecked}
                      onChange={(e) => updatepayInfo({ cc_amt: e.target.value })}
                      onKeyUp={(e) => updateBalance(e.target.value)}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </span>
                </div>

                <div className="duepaymentradio">
                  <div
                    onClick={(e) => handleChange(e, 3, "upi")}
                    style={{ zIndex: 2 }}
                  >
                    <span>

                      UPI
                    </span>
                  </div>
                  <div>
                    <span>
                      <input
                        className="splitinputupi"
                        type="text"
                        placeholder="number@bank.com"
                        onChange={(e) =>
                          updatepayInfo({ upi_input: e.target.value })
                        }
                      />
                    </span>
                    <span>
                      <span>
                        <img className="w-11" src={tranImg} alt="UPI" />
                      </span>{" "}
                      <input
                        className="splitinput w-50"
                        type="text"
                        // disabled={upiChecked}
                        onChange={(e) =>
                          updatepayInfo({ upi_amt: e.target.value })
                        }
                        onKeyUp={(e) => updateBalance(e.target.value)}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </span>
                  </div>
                </div>

                <div className="duepaymentradio">
                  <div
                    onClick={(e) => handleChange(e, 4, "wallet")}
                    style={{ zIndex: 2 }}
                  >
                    <span>

                      Wallets
                    </span>
                  </div>
                  <div>
                    <span>
                      <input
                        className="splitinputwallet splitinputupi"
                        type="text"

                        placeholder="123456789"
                        onChange={(e) =>
                          updatepayInfo({ wallet_input: e.target.value })
                        }
                      />
                    </span>
                    <span>
                      <span>
                        <img className="w-11" src={tranImg} alt="Wallets" />
                      </span>{" "}
                      <input
                        className="splitinput w-50"
                        type="text"
                        // disabled={walletChecked}
                        onChange={(e) =>
                          updatepayInfo({ wallet_amt: e.target.value })
                        }
                        onKeyUp={(e) => updateBalance(e.target.value)}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </span>
                  </div>
                </div>
              </>
            )}
            {(showMulitple || showCoupon || userpayselect) && (
              <>
                {" "}
                <div className="d-flex space-between mb-2 mt-3 clr-red">
                  <span> Balance due amount</span>
                  <span>
                    <img className="w-11" src={tranImg} alt="Due" />
                    {balance}
                  </span>
                </div>
                <div className="modal-footer text-center">
                  <button
                    type="submit"
                    onClick={() => donePayment(-1)}
                    className="btn btn-primary"
                    data-mdb-dismiss="modal">
                    Done
                  </button>
                  &nbsp;
                  <button
                    type="button"
                    onClick={props.oncancel}
                    className="btn btn-secondary"
                    data-mdb-dismiss="modal"
                  >
                    Cancel
                  </button>
                </div>
              </>
            )}
          </div>
        </div>}
      {paymentLink && (
        <Popup
          title="Send Payment Link"
          ptype="modal-md"
          from="transactions"
          content={
            <>
              <div>
                <PaymentLink selecteditems={selecteditems} close={() => setPaymentLink(false)} price={Number(totalamount)} paymentLinkSent={(id) => paymentLinkSent(id)} createdate={createdDate} />
              </div>
            </>
          }
          handleClose={() => setPaymentLink(false)}
        />
      )}
      {sentScreenPopup && (
        <Popup
          title="Payment link"
          ptype="modal-md"
          from="transactions"
          hideClose="true"
          content={
            <>
              <div className="d-flex align-items-center justify-content-center flex-column pb-5 pt-2">
                <h5>Payment link sent successfully.</h5>
                <div className="fs-6">Open link and complete the payment of <strong> &#8377;{totalamount} </strong>within</div>
                <div className="py-3">
                  <ReverseTimer minute={minutes} checkingPaymentStatus={(val) => checkingPaymentStatus(val)} requestPaymentStatus={() => requestPaymentStatus()} />
                </div>

                <p class="mt-4 text-secondary">
                  Please do not refresh or press back.
                </p>
              </div>
              {/* <button className="btn btn-primary">Regenerate Link</button> */}
            </>
          }
          handleClose={() => { setSentScreenPopup(false); setPaymentLinkId(""); }}
        />
      )}

      {showPinelabs && (
        <Popup
          title="Pine Labs POS Payment"
          ptype="modal-md"
          from="transactions"
          content={
            <>
              {/* ── IDLE: device selector + amount input ── */}
              {plStage === "idle" && (
                <div className="p-3">

                  {/* Active device row */}
                  <div className="d-flex align-items-center justify-content-between mb-3 p-2 rounded" style={{ background: '#f5f5f5' }}>
                    <div>
                      <span className="text-muted">POS Device: </span>
                      <span className="fw-600">
                        {plActiveDevice ? (plActiveDevice.deviceName || `Device`) : <span className="text-danger">Not selected</span>}
                      </span>
                      {plActiveDevice?.storeId && <span className="text-muted ms-2">Store: {plActiveDevice.storeId}</span>}
                    </div>
                    {plDevices.length > 0 && (
                      <button className="btn btn-sm btn-outline-secondary" onClick={() => setPlShowDevicePicker(v => !v)}>
                        {plShowDevicePicker ? 'Close' : 'Change'}
                      </button>
                    )}
                  </div>

                  {/* Device picker dropdown */}
                  {plShowDevicePicker && plDevices.length > 0 && (
                    <div className="mb-3 border rounded p-2">
                      <label className="fw-600 mb-2 d-block">Select Device for This Terminal</label>
                      {plDevices.map((d, i) => (
                        <div
                          key={i}
                          className={`d-flex align-items-center justify-content-between p-2 rounded mb-1 ${plActiveDevice?.deviceNumber === d.deviceNumber ? 'bg-primary text-white' : 'bg-light'}`}
                          style={{ cursor: 'pointer' }}
                          onClick={() => plSelectDevice(d)}
                        >
                          <div>
                            <span className="fw-600">{d.deviceName || `Device ${i + 1}`}</span>
                            {d.storeId && <span className={`ms-2 ${plActiveDevice?.deviceNumber === d.deviceNumber ? 'text-white-50' : 'text-muted'}`}>Store: {d.storeId}</span>}
                            {d.deviceNumber && <span className={`ms-2 ${plActiveDevice?.deviceNumber === d.deviceNumber ? 'text-white-50' : 'text-muted'}`}>#{d.deviceNumber}</span>}
                          </div>
                          {plActiveDevice?.deviceNumber === d.deviceNumber && <span>&#10003;</span>}
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="mb-3">
                    <label className="form-label fw-600">Amount (&#8377;)</label>
                    {/* {isAdmin ? (
                      <>
                        <input
                          type="number"
                          className="form-control"
                          value={plAmount}
                          min="1"
                          step="1"
                          onChange={(e) => { setPlAmount(e.target.value); setPlError(""); }}
                          onKeyDown={(e) => e.key === "Enter" && handlePinelabsPay()}
                          autoFocus
                        />
                      </>
                    ) : ( */}
                      <div className="form-control-plaintext fw-600" style={{ fontSize: 16 }}>
                        &#8377; {plAmount}
                      </div>
                    {/* )} */}
                  </div>
                  <div className="mb-3">
                    <label className="form-label fw-600 mb-1" style={{ fontSize: 13 }}>
                      Payment Mode
                      <span className="text-muted fw-normal ms-1" style={{ fontSize: 11 }}>(member chooses on terminal)</span>
                    </label>
                    <div className="d-flex gap-2">
                      {[
                        { label: 'Card', value: 1,  sub: 'Debit / Credit' },
                        { label: 'UPI',  value: 10, sub: 'QR / UPI App'   },
                      ].map(opt => {
                        const active = plPayMode === opt.value;
                        return (
                          <div
                            key={opt.value}
                            onClick={() => setPlPayMode(opt.value)}
                            style={{
                              flex: 1,
                              border: `2px solid ${active ? '#0d6efd' : '#dee2e6'}`,
                              borderRadius: 10,
                              padding: '10px 8px',
                              cursor: 'pointer',
                              background: active ? '#ebf2ff' : '#fafafa',
                              textAlign: 'center',
                              userSelect: 'none',
                              transition: 'border-color 0.15s, background 0.15s',
                            }}
                          >
                            <div style={{ fontSize: 15, fontWeight: 700, color: active ? '#0d6efd' : '#343a40' }}>
                              {opt.label}
                            </div>
                            <div style={{ fontSize: 11, color: active ? '#5b8de8' : '#6c757d', marginTop: 2 }}>
                              {opt.sub}
                            </div>
                            {active && (
                              <div style={{ width: 8, height: 8, background: '#0d6efd', borderRadius: '50%', margin: '5px auto 0' }} />
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  {plError && <div className="text-danger mb-2">{plError}</div>}
                  {plStuckTxn?.ptrid && (
                    <div className="mb-2">
                      <button
                        className="btn btn-warning btn-sm w-100"
                        onClick={handleCancelStuck}
                        disabled={plCancelling}
                      >
                        {plCancelling ? 'Cancelling…' : `Cancel Stuck Transaction (PTRID ${plStuckTxn.ptrid})`}
                      </button>
                    </div>
                  )}
                  <div className="modal-footer px-0 pb-0">
                    <button className="btn btn-primary" onClick={handlePinelabsPay} disabled={!plAmount || !plActiveDevice}>
                      Pay Now
                    </button>
                    <button className="btn btn-secondary" onClick={() => setShowPinelabs(false)}>
                      Cancel
                    </button>
                  </div>
                </div>
              )}

              {/* ── PROCESSING: waiting on POS device ── */}
              {plStage === "processing" && (
                <div className="p-3 text-center">
                  <div className="d-flex justify-content-center mb-3">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Processing...</span>
                    </div>
                  </div>
                  <p className="fw-600 mb-1">
                    {plOrder ? "Waiting for payment on POS device..." : "Sending to POS terminal..."}
                  </p>
                  {plOrder && <p className="text-muted mb-1">Amount: &#8377;{plOrder.amount}</p>}
                  <p className="text-muted mb-1">Customer should tap / swipe card or scan UPI on the terminal</p>
                  {/* <p className="text-muted mb-3">Terminal auto-cancels after 3 minutes. This screen waits up to 4 minutes.</p> */}
                  {plError && (
                    <div className="alert alert-warning py-2 text-start">{plError}</div>
                  )}
                  <button
                    className="btn btn-outline-danger btn-sm"
                    onClick={handlePinelabsCancel}
                    disabled={plCancelling}
                  >
                    {plCancelling ? "Cancelling..." : "Cancel Transaction"}
                  </button>
                </div>
              )}

              {/* ── DONE: result ── */}
              {plStage === "done" && plTxnStatus && (
                <div className="p-3">
                  {plTxnStatus.status === "PAID" ? (
                    <div className="alert alert-success">
                      <h6 className="mb-2">&#10003; Payment Successful</h6>
                      <div className="">
                        <div>Amount: &#8377;{plTxnStatus.amount || plOrder?.amount}</div>
                        {plTxnStatus.paymentMode  && <div>Mode: {plTxnStatus.paymentMode}</div>}
                        {plTxnStatus.cardType     && <div>Card Type: {plTxnStatus.cardType}</div>}
                        {plTxnStatus.approvalCode && <div>Approval Code: {plTxnStatus.approvalCode}</div>}
                        {plTxnStatus.rrn          && <div>RRN: {plTxnStatus.rrn}</div>}
                      </div>
                    </div>
                  ) : (
                    <div className="alert alert-danger">
                      <h6 className="mb-1">&#10007; {plTxnStatus.status === "CANCELLED" ? "Transaction Cancelled" : "Payment Failed"}</h6>
                      <div className="">{plTxnStatus.responseMessage || "Transaction did not complete."}</div>
                    </div>
                  )}
                  <div className="modal-footer px-0 pb-0">
                    <button className="btn btn-secondary btn-sm" onClick={handlePinelabsReset}>
                      Try Again
                    </button>
                    <button className="btn btn-outline-secondary btn-sm" onClick={() => setShowPinelabs(false)}>
                      Close
                    </button>
                  </div>
                </div>
              )}
            </>
          }
          handleClose={() => { if (plStage !== "processing") { plStopPolling(); setShowPinelabs(false); } }}
        />
      )}
      <MDBAlert
        color={Alerttxt.includes("ailed") ? "danger" : "success"}
        autohide
        position='top-right'
        delay={5000}
        appendToBody
        open={Alerttxt !== ""}
        onClose={() => setAlerttxt("")}
      >
        {Alerttxt}
      </MDBAlert>
    </>
  );
};

export default Payments;